module.exports = __webpack_public_path__ + "static/media/diablo-skull.18710d12.svg";